/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Container } from 'flux/utils'
import PasswordResetView from '../../view/pages/public/PasswordResetView'
import PasswordResetStore from '../../store/user/PasswordResetStore'

function getStores() {
  return [PasswordResetStore]
}

function getState() {
  return {
    state: PasswordResetStore.getState()
  }
}

export default Container.createFunctional(PasswordResetView, getStores, getState)
